/**
 * Главная: витрина игровых режимов.
 *
 * Кошко краш стоит первым: это флагманский режим. Остальные карточки ведут
 * в кейсы, слоты и плинко.
 */

import type { Screen } from "../navigation";
import { haptic } from "../lib/telegram";

interface Props {
  onOpen: (tab: Screen) => void;
}

interface GameCard {
  id: string;
  title: string;
  subtitle: string;
  icon: string;
  gradient: string;
  ready: boolean;
  tab?: Screen;
}

const GAMES: GameCard[] = [
  {
    id: "crash",
    title: "Кошко краш",
    subtitle: "Котик бежит — успей забрать, пока не упал",
    icon: "🐈",
    gradient: "from-cat-500/30 via-paws-500/15 to-transparent",
    ready: true,
    tab: "crash",
  },
  {
    id: "cases",
    title: "Котокейсы",
    subtitle: "Открывай кейсы и собирай редкие находки",
    icon: "🎁",
    gradient: "from-purple-500/25 via-night-700/20 to-transparent",
    ready: true,
    tab: "cases",
  },
  {
    id: "slots",
    title: "Котослоты",
    subtitle: "Три в ряд с мурчащими символами",
    icon: "🎰",
    gradient: "from-emerald-500/20 via-night-700/20 to-transparent",
    ready: true,
    tab: "slots",
  },
  {
    id: "plinko",
    title: "Плинко",
    subtitle: "Котик скачет по колышкам вниз",
    icon: "🎱",
    gradient: "from-sky-500/20 via-night-700/20 to-transparent",
    ready: true,
    tab: "plinko",
  },
];

export function HomePage({ onOpen }: Props) {
  return (
    <div className="space-y-4">
      <section className="relative overflow-hidden rounded-3xl border border-white/5 bg-gradient-to-br from-cat-500/25 via-night-800 to-night-900 p-5">
        <div className="relative z-10 max-w-[70%]">
          <p className="text-[11px] font-bold uppercase tracking-widest text-paws-400">
            Честная игра
          </p>
          <h2 className="mt-1 text-xl font-extrabold leading-tight text-white">
            Каждый раунд можно проверить
          </h2>
          <p className="mt-2 text-xs leading-relaxed text-white/55">
            Хеш результата публикуется до ставок, а сид раскрывается после. Мы не
            можем подкрутить исход, даже если захотим.
          </p>
        </div>
        <span className="pointer-events-none absolute -bottom-4 -right-2 text-[110px] leading-none opacity-25">
          🐾
        </span>
      </section>

      <div className="space-y-3">
        {GAMES.map((game) => (
          <button
            key={game.id}
            type="button"
            disabled={!game.ready}
            onClick={() => {
              if (!game.ready || !game.tab) return;
              haptic.tap("medium");
              onOpen(game.tab);
            }}
            className={`relative w-full overflow-hidden rounded-3xl border border-white/5 bg-gradient-to-r ${game.gradient} bg-night-850 p-4 text-left transition-transform active:scale-[0.98] disabled:opacity-55`}
          >
            <div className="flex items-center gap-3.5">
              <span className="text-4xl">{game.icon}</span>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="text-base font-extrabold text-white">{game.title}</h3>
                  {!game.ready && (
                    <span className="rounded-md bg-white/10 px-1.5 py-0.5 text-[9px] font-bold uppercase text-white/50">
                      скоро
                    </span>
                  )}
                </div>
                <p className="mt-0.5 text-xs text-white/50">{game.subtitle}</p>
              </div>
              {game.ready && <span className="text-xl text-paws-400">›</span>}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
